<template>
  <div class="review-real-usage">
    <HeroBanner
        :background-image="bannerImage"
        title="사용 후기"
        sub-title="다비치 히어링 보청기 고객님들의 솔직하고 생생한 경험, <br>
        지역별, 연령별 내 이웃의 후기를 <br>
        직접 확인해보세요."
    />
    <ReviewList
      :reviews="reviews"
      :show-more-button="hasMore"
      :loading="loading"
      @search="handleSearch"
      @review-click="handleReviewClick"
      @load-more="loadMoreReviews"
    />
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import ReviewList from "@/components/ReviewList.vue";
import bannerBg from '@/assets/images/heros/04-top-img.png';
import bannerBg2 from '@/assets/images/heros/04-top-img@2x.png';
import reviewListMixin from '@/mixins/reviewListMixin';
import { fetchRealUsageReview } from '@/api';

export default {
  name: 'ReviewRealUsage',
  components: {
    HeroBanner,
    ReviewList
  },
  mixins: [reviewListMixin],
  data() {
    return {
      bannerImage: [bannerBg, bannerBg2],
      reviewType: 'real-usage' // 라우팅 경로 구분용
    };
  },
  methods: {
    /**
     * API 호출 함수 (mixin에서 사용)
     * - mixin의 loadReviews에서 호출됨
     */
    fetchAPI(params) {
      return fetchRealUsageReview(params);
    }
  }
};
</script>

<style scoped lang="scss">
.review-real-usage {
  width: 100%;
  min-height: 55px;
}
</style>
